import { Constants } from '../../../../configure/models/constants';
import { sendAlertToServer } from '../../util';
const adjustMapboxControlPosition = () => {
    const controlElement = document.querySelector('.mapboxgl-ctrl-top-right');
    if (controlElement) {
        controlElement.style.top = '130px';
        controlElement.style.right = '5px';
    }
};
const initializeRichMap = (mapInit) => {
    try {
        window.rMap = new RichMap(mapInit);
    }
    catch (err) {
        sendAlertToServer(Constants.ALERTS.RICHMAPS_ERROR, JSON.stringify(err));
    }
};
export { adjustMapboxControlPosition, initializeRichMap };
